import { render, staticRenderFns } from "./info-notice.vue?vue&type=template&id=a827ef44&scoped=true"
import script from "./info-notice.vue?vue&type=script&lang=js"
export * from "./info-notice.vue?vue&type=script&lang=js"
import style0 from "./info-notice.vue?vue&type=style&index=0&id=a827ef44&prod&lang=less&scoped=true"
import style1 from "./info-notice.vue?vue&type=style&index=1&id=a827ef44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a827ef44",
  null
  
)

export default component.exports